import ReportDetails from "components/Reports/ReportDetails/reportDetails";
import Home from "pages/Home";
import Login from "pages/PhoneLogin/Login";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ReportsPage from "pages/ReportsPage/reportsPage";
import ContentManagement from "pages/ControlCenter/ContentManagement/ContentManagement";
import UsersPermissionsManagement from "pages/ControlCenter/UsersPermissionsManagement/UsersPermissionsManagement";
import Messages from "pages/Messages/Messages";
import OnlineDashboard from "pages/Dashboards/OnlineDashboard/OnlineDashboard";
import AdministrativeDashboard from "pages/Dashboards/AdministrativeDashboard/AdministrativeDashboard";
import Reports from "pages/ControlCenter/Reports/Reports";
import ParametersManagement from "pages/ControlCenter/ParametersManagement/ParametersManagement";
import RightSidebar from "components/RightSidebar/RightSidebar";
import { useRole } from "hooks/useRole";
import { UserRole } from "components/Reports/reportAssets/assets";
import "assets/styles/style.scss";

const AppRouter = () => {
  // add this to redux store when adding the admin section to the project
  const isAdmin = false;
  const role = useRole();
  const isControlCenter = role === UserRole.CONTROLCENTER;
  const initialPage = isAdmin ? <Home /> : <Navigate to="/login" />;

  const protectedRoutes = {
    "/reports/inprogress": <ReportsPage />,
    "/reports/followup": <ReportsPage />,
    "/reports/followup-messages": <Messages />,
    "/reports/inprogress/:reportId": <ReportDetails />,
    "/reports/followup/:reportId": <ReportDetails />,
    "/control-center/manage-content/*": <ContentManagement />,
    "/control-center/manage-parameters/*": <ParametersManagement />,
    "/control-center/users-permissions/*": <UsersPermissionsManagement />,
    "/control-center/online-dashboard/*": <OnlineDashboard />,
    "/control-center/administrative-dashboard/*": <AdministrativeDashboard />,
    "/control-center/reports/*": <Reports />,
    // userslist: UsersList,
  };

  return (
    <div className="content-container">
      {isControlCenter && <RightSidebar />}
      <div
        className="app-content"
        style={{ width: isControlCenter ? "88%" : "100%" }}
      >
        <Routes>
          {/* public routes */}
          {/* The <Home/> component will be use for the admins part when we will reach to it  */}
          <Route path="/" element={initialPage} />

          <Route path="login" element={<Login />} />
          {/* protected routes */}
          {/* now protected by cookie detection on requests from server - can be protected by token aprroach with the RequireAuth component that is on comment here */}
          {/* <Route element={<RequireAuth />}> */}
          {Object.keys(protectedRoutes).map((route) => {
            return (
              <Route
                key={route}
                path={route}
                element={protectedRoutes[route]}
              />
            );
          })}
          {/* </Route> */}
        </Routes>
      </div>
    </div>
  );
};

export default AppRouter;
